import { render, staticRenderFns } from "./chart-v3-intro.vue?vue&type=template&id=5dd03d8d"
import script from "./chart-v3-intro.vue?vue&type=script&lang=js"
export * from "./chart-v3-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports